<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/okrs',
          title: 'OKRs'
        }
      ]"
      :value="okrsPage.hero_section"
    >
      <template v-if="okrsPage.hero_section.cta" #cta>
        <HeroCta :value="okrsPage.hero_section.cta" />
      </template>
    </HeroSection>

    <ContactDifferentiatorsSection
      :aspect-ratio="1"
      :value="okrsPage.contact_differentiators_section"
      class="mb-8 hero-section hero-below-offset"
    >
      <template #form>
        <ContactForm
          :fields="{ inquiryType: false, inquiryProduct: false }"
          :submit-text="
            okrsPage.contact_differentiators_section.contact_form.action
          "
          default-inquiry-product="okrs"
          default-inquiry-type="general"
        />
      </template>
    </ContactDifferentiatorsSection>

    <LogoBarSection
      :items="logos"
      :value="okrsPage.logo_bar_section"
      class="mb-16"
    />

    <ServiceDetailSection
      class="mb-16"
      :value="okrsPage.service_detail_section"
    />

    <PackageComparisonSection
      :value="okrsPage.package_comparison_section"
      class="mb-16"
    />

    <DividerSection class="mb-8" />

    <VerticalStorySection
      :value="okrsPage.vertical_story_section1"
      class="mb-4"
    />

    <HomeWhyAgileSection
      :value="okrsPage.home_why_agile_section"
      class="mb-4"
    />

    <PromotedResourcesSection
      :value="okrsPage.promoted_resources_section"
      class="mb-16"
    />

    <DividerSection class="mb-8" />

    <VerticalStorySection
      :value="okrsPage.vertical_story_section2"
      class="mb-8"
    />

    <DividerSection class="mb-8" />

    <ContactCtaSection :value="okrsPage.contact_cta_section" class="mb-16" />
  </div>
</template>

<script setup>
defineProps({
  logos: {
    required: true,
    type: Array
  },
  okrsPage: {
    required: true,
    type: Object
  }
})
</script>
